/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type EvaluationResultSchemaStatus = typeof EvaluationResultSchemaStatus[keyof typeof EvaluationResultSchemaStatus];


export const EvaluationResultSchemaStatus = {
  pending: 'pending',
  evaluating: 'evaluating',
  complete: 'complete',
  failed: 'failed',
} as const;
